import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import { Modal } from '@zeeve-platform/modal-component';
import { deleteTheEndpoint } from '../../../services/apisService';
import polkadotLogo from '../../../images/Polkadot_Logo2.svg';
import userImg from '../../../images/user.svg';
import cloudImg from '../../../images/SoundCloud.png';
import Matrics from './metrics';
import Basics from './basics';
import Urls from '../../../utils/util';
import Loading from '../../../components/common/loader';

function EndpointDetailsMetricsBody() {
  const { id } = useParams<{ id: string }>();
  const [endpointName, setEndpointName] = useState<string>('');
  const [activeTab, setActiveTab] = useState<string>('Basics');
  const [message, setMessage] = useState<string>('');
  const [loaderShow, setLoaderShow] = useState<boolean>(false);
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [isYes, setIsYes] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>('Are you sure you want to delete endpoint?');
  const [showConfirmBtn, setShowConfirmBtn] = useState(true);

  /** get value of 'from' key to set breadcrumb path */
  const from = localStorage.getItem('from') || '';
  const path_url = localStorage.getItem('workspace_url') || '';

  const paths = [
    { name: 'Dashboard', path: Urls.getDashboardUrl() },
    {
      name: from === 'workspace' ? 'Workspaces' : 'Shared RPC APIs',
      path: from === 'workspace' ? Urls.getWorkspaceUrl() : Urls.getEndpointsUrl(),
    },
  ];

  if (from === 'workspace') {
    paths.push({
      name: localStorage.getItem('workspaceName') as string,
      path: `${Urls.getWorkspaceUrl()}/${path_url}`,
    });
  }

  const clickOnTab = (value: string) => {
    setActiveTab(value);
  };

  const deleteEndpoint = async () => {
    if (id) {
      setIsYes(true);
      setLoaderShow(true);
      setModalTitle('Status');
      setShowConfirmBtn(true);
      const response: any = await deleteTheEndpoint(id);
      setLoaderShow(false);
      setShowConfirmBtn(false);
      if (response && response.success) {
        setMessage(response.data.message);
        window.open(Urls.getDashboardUrl(), '_self');
      } else {
        setIsYes(false);
        setMessage('Error occured while deleting endpoint');
      }
    }
  };
  return (
    <section className="px-5 col-12">
      <div className="mt-5 col-11 mx-auto">
        <img src={polkadotLogo} alt="polkadot-logo" className="mb-3" width="120px" />
        <div className="row align-items-center">
          <div className="col-6">
            <Breadcrumb
              prefixLink={paths}
              activeLink={endpointName}
              textSize={13}
            />
          </div>
          <div className="col-6 text-end cursor">
            <i className="fa-regular fa-trash-can fs-5" aria-hidden onClick={() => setModalShow(true)} />
          </div>
        </div>

        <div className="col-12 mt-5">
          <ul className="nav nav-tabs mt-4" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className={`px-4 nav-link ${activeTab === 'Basics' ? 'active' : ''}`}
                id="home-tab"
                data-bs-toggle="tab"
                type="button"
                role="tab"
                onClick={() => clickOnTab('Basics')}
              >
                <img src={userImg} alt="" className="px-1" />
                <span className="align-middle">Basics</span>
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`px-4 nav-link ${activeTab === 'Matrics' ? 'active' : ''}`}
                id="profile-tab"
                data-bs-toggle="tab"
                type="button"
                role="tab"
                onClick={() => clickOnTab('Matrics')}
              >
                <img src={cloudImg} alt="" className="px-1" />
                <span className="align-middle">Metrics</span>
              </button>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div>
              <div className="mt-3">
                {activeTab === 'Basics' && (
                <Basics
                  setEndpointName={setEndpointName}
                />
                )}
              </div>
            </div>
            <div>
              {activeTab === 'Matrics' && (<Matrics />)}
            </div>
          </div>
        </div>
      </div>
      {loaderShow && <Loading />}
      <Modal
        show={modalShow}
        onHide={() => {
          setModalShow(false);
          setIsYes(false);
          setMessage('');
          setModalTitle('Are you sure you want to delete endpoint?');
          setShowConfirmBtn(true);
        }}
        title={modalTitle}
        visibleFooter
        visibleFooterCloseButton
        disableConfirmBtn={isYes}
        visibleHeaderCloseIcon={false}
        visibleConfirmBtn={showConfirmBtn}
        confirmBtnText="Yes"
        onConfirm={deleteEndpoint}
        confirmBtnClassName=""
      >
        <p className="status text-center mt-3">{message}</p>
      </Modal>
    </section>
  );
}

export default EndpointDetailsMetricsBody;